import { Link } from 'react-router-dom';

const programs = [
  {
    icon: 'ri-bank-line',
    title: 'Financial Inclusion',
    description: 'Providing small loans to empower entrepreneurs and lift families out of poverty through sustainable income generation.',
    color: 'text-emerald-600',
    bg: 'bg-emerald-50',
  },
  {
    icon: 'ri-computer-line',
    title: 'ICT Training',
    description: 'Equipping youth with digital skills for the modern economy — from basic computing to web development.',
    color: 'text-blue-600',
    bg: 'bg-blue-50',
  },
  {
    icon: 'ri-music-2-line',
    title: 'Music Training',
    description: 'Nurturing musical talents in youth through professional coaching, choir development, and instrument training.',
    color: 'text-purple-600',
    bg: 'bg-purple-50',
  },
  {
    icon: 'ri-scissors-line',
    title: 'Tailoring',
    description: 'Vocational tailoring and fashion design skills that open doors to self-employment and sustainable livelihoods.',
    color: 'text-pink-600',
    bg: 'bg-pink-50',
  },
  {
    icon: 'ri-hammer-line',
    title: 'Welding & Adjustment',
    description: 'Technical welding and metalwork skills preparing youth for careers in construction and manufacturing.',
    color: 'text-orange-600',
    bg: 'bg-orange-50',
  },

  {
    icon: 'ri-plant-line',
    title: 'Food Security',
    description: 'Promoting sustainable agriculture and nutrition programs to ensure communities have access to healthy food.',
    color: 'text-green-600',
    bg: 'bg-green-50',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: 'Health Counseling',
    description: 'Community health education, counseling, and outreach to improve overall wellness and disease prevention.',
    color: 'text-red-600',
    bg: 'bg-red-50',
  },
  {
    icon: 'ri-user-heart-line',
    title: 'Elderly & Disability Care',
    description: 'Compassionate support programs for the elderly and persons with disabilities ensuring dignity and inclusion.',
    color: 'text-amber-600',
    bg: 'bg-amber-50',
  },
];

export default function ProgramsPreview() {
  return (
    <section className="bg-[#F8F8F8] py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block text-[#ADD8E6] text-xs font-bold uppercase tracking-widest mb-3 border-b-2 border-[#ADD8E6] pb-1">
            What We Do
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-[#003366] mb-4">Our Programs</h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base leading-relaxed">
            Holistic programs designed to address the real needs of communities across Uganda — building capacity and fostering dignity.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {programs.map((prog) => (
            <div
              key={prog.title}
              className="bg-white rounded-xl p-6 hover:-translate-y-1 transition-transform duration-200 hover:shadow-md group"
            >
              <div className={`w-14 h-14 flex items-center justify-center rounded-xl ${prog.bg} mb-4`}>
                <i className={`${prog.icon} text-2xl ${prog.color}`} />
              </div>
              <h3 className="text-[#003366] font-bold text-lg mb-2">{prog.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed mb-4">{prog.description}</p>
              <Link
                to="/programs"
                className="text-[#ADD8E6] text-sm font-semibold flex items-center gap-1 hover:text-[#003366] transition-colors cursor-pointer"
              >
                Learn More
                <i className="ri-arrow-right-line text-base" />
              </Link>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/programs"
            className="inline-block px-8 py-3 border-2 border-[#003366] text-[#003366] font-semibold rounded-lg hover:bg-[#003366] hover:text-white transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            View All Programs
          </Link>
        </div>
      </div>
    </section>
  );
}
